// extracted by mini-css-extract-plugin
export default {"root":"StripeElementsUpdatePaymentMethod_root__2OvRW","errorContainer":"StripeElementsUpdatePaymentMethod_errorContainer__L-d82"};